<template>
  <transition
    name="fade-out"
    @before-leave="onBeforeLeave"
    @after-leave="onAfterLeave"
  >
    <div v-if="!isHiding" class="fixed inset-0 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 flex items-center justify-center z-50">
      <div class="text-center">
        <!-- Animated Spinner -->
        <div class="mb-8">
          <div class="relative w-24 h-24 mx-auto">
            <!-- Outer ring -->
            <div class="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-500 border-r-indigo-500 animate-spin"></div>
            <!-- Middle ring -->
            <div class="absolute inset-2 rounded-full border-4 border-transparent border-b-green-500 border-l-purple-500 animate-spin" style="animation-direction: reverse;"></div>
            <!-- Inner circle -->
            <div class="absolute inset-4 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center">
              <i class="pi pi-chart-bar text-white text-2xl"></i>
            </div>
          </div>
        </div>

        <!-- Text with animation -->
        <div class="space-y-3">
          <h2 class="text-2xl font-bold text-slate-800 dark:text-slate-100">
            {{ title }}
          </h2>
          <p class="text-slate-600 dark:text-slate-400 font-medium">
            {{ subtitle }}
            <span class="inline-block ml-1">
              <span class="animate-bounce" style="animation-delay: 0s;">.</span>
              <span class="animate-bounce" style="animation-delay: 0.2s;">.</span>
              <span class="animate-bounce" style="animation-delay: 0.4s;">.</span>
            </span>
          </p>
        </div>

        <!-- Belirsiz (indeterminate) ilerleme cubugu — sure onceden bilinemedigi icin (token
             yenileme / lisans / yetki API'leri) sahte bir yuzde uretmek yerine dogru olan bu. -->
        <div class="mt-8 max-w-xs mx-auto">
          <div class="h-1 bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
            <div class="loading-screen-progress h-full rounded-full bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500"></div>
          </div>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-2">
{{ message }}
</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LoadingScreen",
  props: {
    title: {
      type: String,
      default: "Veriler Yükleniyor"
    },
    subtitle: {
      type: String,
      default: "Lütfen bekleyiniz"
    },
    message: {
      type: String,
      default: "Veriler hazırlanıyor..."
    }
  },
  data() {
    return {
      isHiding: false,
    };
  },
  methods: {
    // Disaridan (ör. ref ile) cagrilabilir - fade-out'u tetikler. Sahte yuzde ilerlemesi
    // kaldirildi (bkz. commit gerekcesi): sure onceden olculemiyordu, ilerleme her zaman
    // gercek isten bagimsiz uyduruluyordu.
    hideLoading() {
      this.isHiding = true;
    },
    onBeforeLeave() {
      this.$emit('before-leave');
    },
    onAfterLeave() {
      this.$emit('after-leave');
    },
  },
};
</script>

<style scoped>
.fade-out-enter-active,
.fade-out-leave-active {
  transition: opacity 0.8s ease;
}

.fade-out-enter-from {
  opacity: 0;
}

.fade-out-leave-to {
  opacity: 0;
}

.fade-out-enter-to,
.fade-out-leave-from {
  opacity: 1;
}

.loading-screen-progress {
  width: 40%;
  animation: loading-screen-slide 1.1s ease-in-out infinite;
}

@keyframes loading-screen-slide {
  0% { margin-left: -40%; width: 40%; }
  50% { width: 60%; }
  100% { margin-left: 100%; width: 40%; }
}

@media (prefers-reduced-motion: reduce) {
  .loading-screen-progress {
    animation: none;
    margin-left: 0;
    width: 100%;
    opacity: 0.6;
  }
}
</style>
